import { ModalComponent } from "../../../../components/modal";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { Button, TextField } from "@mui/material";
import { InputComponent } from "../../../../components/input";
import { CEPMaskCustom } from "../../../../components/mask";
import { ClientsService } from "../../../../services/clients";

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: (allowed: boolean) => void;
    verify?: boolean
}

export const ModalCEP = ({
    onClose,
    open,
    onConfirm,
    verify
}: Props) => {
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState("")

    const handleCEP = () => {
        setLoading(true)

        if (verify) {
            ClientsService.verifyCEP(value)
                .then(() => onConfirm(true))
                .catch(() => onConfirm(false))
                .finally(() => {
                    setLoading(false)
                    onClose()
                    setValue("")
                })
        } else {
            setLoading(false)
            onClose()
            setValue("")
        }
    }

    return (
        <ModalComponent
            open={open}
            titleProps={{
                fontSize: "2rem",
                fontWeight: 600
            }}
            description={verify ? "Para verificar se nossos serviços estão disponíveis na sua região, é necessário que informe seu CEP." : <>
                Já estamos presentes em mais de 800 cidades.
                <br />
                <br />
                <strong>Para simular procure um parceiro Gyroo em sua região!</strong>
            </>}
            descriptionProps={{
                fontSize: "1.4rem",
                fontWeight: 400,
                sx: {
                    opacity: 1,
                    ...(!verify && {
                        textAlign: "center"
                    })
                }
            }}
            onClose={() => {
                if (!verify) {
                    onClose()
                }
            }}
            showButtonClose={!verify}
        >
            {verify && <InputComponent
                autoFocus
                label="CEP"
                mask={CEPMaskCustom}
                loading={loading}
                disabled={loading}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                fullWidth
                sx={{
                    width: "110% !important"
                }}
            />}

            <LoadingButton
                variant="contained"
                color="primary"
                sx={{ width: "100%", mt: verify ? "2rem" : "0rem" }}
                loading={loading}
                disabled={verify && value.length < 9}
                onClick={handleCEP}
            >
                {verify ? "Pesquisar" : "Fechar"}
            </LoadingButton>
        </ModalComponent>
    );
};
